import * as React from 'react';

import PageComponent from '/Users/cainiao/Documents/project/fpx-giws-web/src/pages/Billboard';

const PageComponentName = PageComponent;

export default PageComponentName;
